import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import { Dispatch, SetStateAction } from 'react'
import { Reply } from '@mui/icons-material';
import { Entities } from './Entities';

export const HardDeleteDialog : React.FC<{idToDelete: number,
                                      showHardDeleteDialog : boolean, 
                                      setShowHardDeleteDialog : Dispatch<SetStateAction<boolean>>,
                                      handleHardDelete : (id: number) => Promise<() => void>,
                                      entity : Entities }> = (props) => {

    const { idToDelete, showHardDeleteDialog, setShowHardDeleteDialog, handleHardDelete, entity } = props

    const handleTextInDialog = (entity : Entities) : String => {
      switch (entity) {
        case Entities.CUSTOMER: 
        return `Na pewno chcesz usunąć rodzica? To usunie również wszystkie połączenia rodzic-posiłek. 
        Jeśli rodzic został utworzony w tym miesiącu, zostanie on usunięty całkowicie 
        (połączenia rodzic-posiłek również). Jeśli powstał wcześniej, zostanie zdezaktywowany z datą 
        na koniec poprzedniego miesiąca`
        case Entities.MEAL: 
        return `Na pewno chcesz usunąć posiłek? To usunie również wszystkie połączenia posiłek-rodzic. 
        Usunięcie posiłku polega na jego dezaktywacji z datą na koniec zeszłego miesiąca. Połączenia posiłek rodzic
        również są dezaktywowane z tą datą, zaś te, utworzone w tym miesiącu są usuwane całkowicie.`
        default: return 'Na pewno chcesz usunąć?'
      }
    }

    return (
    <>
      <Dialog
        open={showHardDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{"Czy na pewno chcesz wykonać tę akcję?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {handleTextInDialog(entity)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" 
          color={`error`} 
          startIcon={<DeleteIcon />} 
          onClick={() => {handleHardDelete(idToDelete); setShowHardDeleteDialog(false)}}>{`Usuń`} </Button>
          <Button variant="outlined" 
          color={`error`} 
          startIcon={<Reply />} 
          onClick={() => setShowHardDeleteDialog(false)}>Anuluj</Button>
        </DialogActions>
      </Dialog>
    </>
    )
}